module.exports = __webpack_public_path__ + "static/img/info_wind.b9c192c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/flydragonfish/info_wind.png
// module id = jczU
// module chunks = 0